export const featuredTestimonials = [
  {
    initials: 'MJ',
    text: 'Het scheelt me zóveel tijd. Ik begon de maandag volledig voorbereid, zonder gestress. Echt een aanrader.',
    author: 'Mark J.',
    role: 'Functionele coach · Utrecht',
    bg: 'bg-blue-600',
  },
  {
    initials: 'SV',
    text: 'Ik twijfelde eerst, maar het viel me heel positief op. Met de drie versies geef ik zonder stress les aan groepen met verschillende niveaus.',
    author: 'Sanne V.',
    role: 'Instructeur · Rotterdam',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'DB',
    text: 'In 10 minuten staat mijn les en dat merk je. Voor deze prijs raad ik het iedereen aan.',
    author: 'Daan B.',
    role: 'Bokscoach · Amsterdam',
    bg: 'bg-blue-600',
  },
]

export const coachTestimonials = [
  {
    initials: 'LD',
    name: 'Lotte D.',
    location: 'Eindhoven',
    text: 'Ik begon de maandag altijd uitgeput. Nu open ik het deel en binnen 5 minuten staat mijn les klaar.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'JS',
    name: 'Jeroen S.',
    location: 'Groningen',
    text: 'Ik kocht het een beetje sceptisch, maar het verraste me: het is veel completer dan ik had verwacht.',
    bg: 'bg-cyan-600',
  },
  {
    initials: 'FK',
    name: 'Femke K.',
    location: 'Den Haag',
    text: 'De warm-ups en afsluitingen zijn goud waard. Je merkt dat elke les van begin tot eind structuur heeft.',
    bg: 'bg-blue-600',
  },
  {
    initials: 'BM',
    name: 'Bram M.',
    location: 'Nijmegen',
    text: 'Het scheelt me ontzettend veel tijd. Ik verlies mijn zondagen niet meer aan het bouwen van sessies. Aanrader!',
    bg: 'bg-cyan-600',
  },
]
